import { render, staticRenderFns } from "./order-submit-subscribe.vue?vue&type=template&id=4a86db6a&scoped=true"
import script from "./order-submit-subscribe.vue?vue&type=script&lang=ts"
export * from "./order-submit-subscribe.vue?vue&type=script&lang=ts"
import style0 from "./order-submit-subscribe.vue?vue&type=style&index=0&id=4a86db6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86db6a",
  null
  
)

export default component.exports